import React from 'react';
import { User, UserType } from '../../types/admin';
import './UserDetailView.css';

interface UserDetailViewProps {
	user: User;
	isOpen: boolean;
	onClose: () => void;
	onEdit: (user: User) => void;
	onToggleStatus: (userId: string) => void;
	onDelete: (userId: string) => void;
	onManageVerification?: (user: User) => void;
}

export const UserDetailView: React.FC<UserDetailViewProps> = ({ user, isOpen, onClose, onEdit, onToggleStatus, onDelete, onManageVerification }) => {
	const getUserTypeLabel = (type: UserType) => {
		switch (type) {
			case UserType.ADMIN:
				return 'Administrator';
			case UserType.SOCIAL:
				return 'Socijalni radnik';
			case UserType.HEALTH:
				return 'Zdravstveni radnik';
			default:
				return type;
		}
	};

	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleDateString('sr-RS', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		});
	};

	const handleDelete = () => {
		if (window.confirm(`Da li ste sigurni da želite da obrišete korisnika ${user.firstName} ${user.lastName}?`)) {
			onDelete(user.id);
			onClose();
		}
	};

	const handleToggleStatus = () => {
		const action = user.isActive ? 'deaktivirate' : 'aktivirate';
		if (window.confirm(`Da li ste sigurni da želite da ${action} korisnika ${user.firstName} ${user.lastName}?`)) {
			onToggleStatus(user.id);
		}
	};

	if (!isOpen) return null;

	return (
		<div className='modal-overlay'>
			<div className='modal-content user-detail-modal'>
				<div className='modal-header'>
					<h3>Detalji korisnika</h3>
					<button className='close-btn' onClick={onClose}>
						×
					</button>
				</div>

				<div className='user-detail-content'>
					{/* User Status Badge */}
					{/* <div className='status-section'>
						<span className={`status-badge ${user.isActive ? 'active' : 'inactive'}`}>{user.isActive ? 'AKTIVAN' : 'NEAKTIVAN'}</span>
						<span className={`type-badge ${user.type}`}>{getUserTypeLabel(user.type)}</span>
					</div> */}

					{/* Basic Information */}
					<div className='detail-section'>
						<h4>Osnovne informacije</h4>
						<div className='detail-grid'>
							<div className='detail-item'>
								<label>Ime:</label>
								<span>{user.firstName}</span>
							</div>
							<div className='detail-item'>
								<label>Prezime:</label>
								<span>{user.lastName}</span>
							</div>
							<div className='detail-item'>
								<label>Email:</label>
								<span>{user.email}</span>
							</div>
							<div className='detail-item'>
								<label>Telefon:</label>
								<span>{user.phoneNumber}</span>
							</div>
							<div className='detail-item'>
								<label>Tip korisnika:</label>
								<span>{getUserTypeLabel(user.type)}</span>
							</div>
							<div className='detail-item'>
								<label>Ustanova:</label>
								<span>{user.institution}</span>
							</div>
						</div>
					</div>

					{/* System Information */}
					<div className='detail-section'>
						<h4>Sistemske informacije</h4>
						<div className='detail-grid'>
							<div className='detail-item'>
								<label>Kreiran:</label>
								<span>{formatDate(user.createdAt)}</span>
							</div>
							<div className='detail-item'>
								<label>Poslednja izmena:</label>
								<span>{formatDate(user.updatedAt)}</span>
							</div>
							<div className='detail-item'>
								<label>Poslednji login:</label>
								<span>{user.lastLoginAt ? formatDate(user.lastLoginAt) : 'Nikad se nije ulogovao'}</span>
							</div>
							<div className='detail-item'>
								<label>Status:</label>
								<span className={` ${user.isActive ? 'status-active' : 'status-inactive'}`}>{user.isActive ? 'Aktivan' : 'Neaktivan'}</span>
							</div>
						</div>
					</div>

					{/* Email Verification Section */}
					{!user.emailVerified && (
						<div className='detail-section verification-section'>
							<h4>Email verifikacija</h4>
							<div className='verification-info'>
								<p className='warning-text'>⚠️ Korisnik nije verifikovao svoju email adresu i ne može se prijaviti na sistem.</p>
								<p>Da bi korisnik mogao da se prijavi, potrebno je da:</p>
								<ul>
									<li>Verifikuje svoju email adresu</li>
									<li>Postavi lozinku</li>
								</ul>
							</div>
						</div>
					)}

					{/* Actions */}
					<div className='detail-actions'>
						<button className='btn btn-primary' onClick={() => onEdit(user)}>
							Uredi korisnika
						</button>

						{!user.emailVerified && onManageVerification && (
							<button className='btn btn-warning' onClick={() => onManageVerification(user)}>
								Upravljaj verifikacijom
							</button>
						)}

						<button className={`btn ${user.isActive ? 'btn-warning' : 'btn-success'}`} onClick={handleToggleStatus}>
							{user.isActive ? 'Deaktiviraj' : 'Aktiviraj'} korisnika
						</button>

						<button className='btn btn-danger' onClick={handleDelete}>
							Obriši korisnika
						</button>
					</div>
				</div>

				<div className='modal-footer'>
					<button className='btn btn-secondary' onClick={onClose}>
						Zatvori
					</button>
				</div>
			</div>
		</div>
	);
};
